<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
    <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
        <div class="col-sm-12 px-0 align-self-end">
          <div class="row align-items-center">
            <div class="col-sm-10">
              <h5 class="light-header bold">
                {{ 'PASSCODE.LBL_TITLE' | translate}}
              </h5>
            </div>
          </div>
          <hr class="mt-0 mb-3" />
        </div>
        <div class="pt-3">
          <div class="container border rounded p-3 bold col-sm-5">
            <form [formGroup]="iSForm">
              <div class="form-group row" *ngIf="isAdminUserPasscode">
                <label for="adminpasscode" class="col-sm-4 col-form-label">Admin Passcode</label>
                <div class="col-sm-6"> 
                   <input type="text" class="form-control bold" id="adminpasscode"  autocomplete="off"
                   [(ngModel)]="adminpasscode" formControlName="adminpasscode"/> 
                </div>
                <div class="col-sm-2 pt-1">
                  <button type="button" class="btn btn-primary btn-sm" *ngIf="isAdminUserPasscode"
                  (click)="updateAdminPasscodeBtnClickEvent()"> <i class="far fa-save"></i> Save</button>
                </div>
              </div>   
              <div class="form-group row" *ngIf="!isAdminUserPasscode">
                <label for="superuserpasscode" class="col-sm-4 col-form-label">Superuser Passcode</label>
                <div class="col-sm-6"> 
                   <input type="text" class="form-control bold" id="superuserpasscode"  autocomplete="off"
                   [(ngModel)]="superuserpasscode" formControlName="superuserpasscode"/> 
                </div>
                <div class="col-sm-2 pt-1">
                  <button type="button" class="btn btn-primary btn-sm" *ngIf="!isAdminUserPasscode"
                  (click)="updateSuperuserPasscodeBtnClickEvent()"> <i class="far fa-save"></i> Save</button>
                </div>
              </div>           
            </form>
          </div>
		  </div>
    </div>
  </div>